export default function Slide({
  slide,
  isActive,
  categoriesBanner,
  shouldLoad = true,
  priority = false,
}) {
  return (
    <div
      className={`absolute inset-0 transition-opacity duration-500 ease-in-out text-white ${
        isActive ? 'opacity-100 z-10' : 'opacity-0 z-0'
      }`}
    >
      {slide.image ? (
        // Slides further ahead aren't fetched until the carousel nears them,
        // so slow connections spend their bandwidth on what's on screen.
        shouldLoad && (
          // <picture> makes the browser download only the image for the
          // current breakpoint (hidden <img>s still download).
          <picture className="block h-full">
            <source media="(min-width: 768px)" srcSet={slide.image} />
            <img
              src={slide.imageMobile || slide.image}
              alt="Slide image"
              loading={priority ? 'eager' : 'lazy'}
              fetchpriority={priority ? 'high' : 'low'}
              decoding={priority ? 'sync' : 'async'}
              className={`w-full h-full object-cover ${categoriesBanner !== false ? 'md:rounded-[10px]' : ''}`}
            />
          </picture>
        )
      ) : (
        <div
          className="w-full h-full flex items-center justify-center"
          style={{ backgroundColor: '#0D1BFF' }}
        >
          <p className="text-white">Image not available</p>
        </div>
      )}
      {/* <div className="absolute inset-0 bg-black/40 rounded-xl" /> */}
      <div className="absolute   inset-0  md:inset-24 p-3  md:text-justify md:flex hidden flex-col">
        {slide.content}
      </div>
    </div>
  );
}
